import { Routes } from '@angular/router';
import { privateGuard, publicGuard } from './core/guards/auth.guard';
import { ConfirmPasswordComponent } from './ui/pages/auth/confirmPassword/confirm-password.component';
import { PageNotFoundComponent } from './ui/pages/notFound/page-not-found.component';


export const routes: Routes = [
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
    { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
    { path: 'change-password', component: ConfirmPasswordComponent },
    {
        canActivate: [publicGuard],
        path: 'auth',
        loadChildren: () => import('./modules/authentication/auth.module').then(m => m.AuthModule)
    },
    {
        canActivate: [privateGuard],
        path: 'home',
        loadChildren: () => import('./ui/pages/home/home.module').then(m => m.HomeModule)
    },
    { path: '**', component: PageNotFoundComponent }
];
